module.exports = __webpack_public_path__ + "img/ios.1e2f446b.svg";